import { InputLabel, Box } from "@mui/material";
import { Link } from "react-router-dom";
import Linkify from "linkify-react";

const ChatMessage = (props) => {
  const isPatientMessage = props.fromName == props.selectedRoom.name;
  const isLoggedUserMessage = props.fromId === props.userId;
  
  const messageStyle = {
    container: {
      width: "100%",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    },
    message: {
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.003em",
      whiteSpace: "pre-wrap !important",
      overflowWrap: "break-word",
    },
    datetime: {
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "16px",
    },
    name: {
      fontWeight: "600",
      fontSize: "12px",
      lineHeight: "16px",
    },
    text: {
      patient: {
        color: "#575565",
        textAlign: "left",
      },
      doctor: {
        color: "#575565",
        textAlign: "right",
      },
      loggedUser: {
        color: "#FCFCFC",
        textAlign: "right",
      },
    },
    box: {
      base: {
        width: "fit-content",
        margin: "5px",
        padding: "15px",
        maxWidth: "400px",
        background: "#DADADA",
        borderRadius: "13.248px 13.248px 13.248px 0px",
      },
      patient: {
        alignSelf: "flex-start",
      },
      doctor: {
        alignSelf: "flex-end",
      },
      loggedUser: {
        background: "#3988E3",
        alignSelf: "flex-end",
      },
    },
  };

  const getTextStyle = () => {
    if (isPatientMessage) return messageStyle.text.patient;
    if (isLoggedUserMessage) return messageStyle.text.loggedUser;
    return messageStyle.text.doctor;
  };

  const getBoxStyle = () => {
    const baseStyle = messageStyle.box.base;
    if (isPatientMessage) return [baseStyle, messageStyle.box.patient];
    if (isLoggedUserMessage) return [baseStyle, messageStyle.box.loggedUser];
    return [baseStyle, messageStyle.box.doctor];
  };

  return (
    <Box sx={messageStyle.container}>
      <Box sx={getBoxStyle()}>
        {props.attachmentType === "image" ? (
          <img
            style={{ maxWidth: "350px", maxHeight: "350px" }}
            src={props.attachmentFile}
          />
        ) : props.attachmentFile.toString().substr(-3) === "pdf" ? (
          <Link
            to={props.attachmentFile.href}
            download={props.attachmentTitle}
            target="_blank"
            rel="noreferrer"
          >
            <img
              style={{ maxWidth: "150px", maxHeight: "150px" }}
              src={"/pdfimage.png"}
            />
            <p>{props.attachmentTitle}</p>
          </Link>
        ) : props.attachmentFile.toString().substr(-3) === "mp4" ||
          props.attachmentFile.toString().substr(-3) === "avi" ||
          props.attachmentFile.toString().substr(-4) === "webm" ? (
          <>
            <video controls>
              <source src={props.attachmentFile} />
            </video>
          </>
        ) : (
          <></>
        )}

        <InputLabel sx={[messageStyle.message, getTextStyle()]}>
          <Linkify options={{ target: "_blank" }}>{props.message}</Linkify>
        </InputLabel>
        <InputLabel sx={[messageStyle.datetime, getTextStyle()]}>
          {props.datetime}
        </InputLabel>
        <InputLabel sx={[messageStyle.name, getTextStyle()]}>
          {props.fromName}
        </InputLabel>
      </Box>
    </Box>
  );
};
export default ChatMessage;
